<template>
    <div id="lead-list-page">
        <h3 class="title" v-if="showTitle">Meta Leads</h3>
        <div v-if="checkboxOption.selectedRowKeys.length" class="selection-bar">
            <section class="uncheck" @click="unselectAll">
                <span class="material-icons"> arrow_back </span>
                {{ $t("chatbotv2.uncheckAll") }}
            </section>
            <section class="select" @click="selectAll">{{ $t("chatbotv2.selectAll") }}</section>
            <section class="select" @click="deleteAll">{{ $t("search.integration.deleteAll") }}</section>
            <section class="queries">
                +{{ `${checkboxOption.selectedRowKeys.length} ${$t("wp.contactSelected")}` }}
            </section>
            <section class="actions">
                <a-button class="d-none" ghost disabled>{{ $t("wp.sendBroadcastMessage") }}</a-button>
            </section>
        </div>
        <div class="toolbox">
            <div>
                <slot name="left-actions"></slot>
            </div>
            <div>
                <slot name="middle-actions"></slot>
            </div>
            <div class="buttons"></div>
        </div>
        <div class="table-wrapper">
            <div class="toolbar">
                <div class="toolbar-filter">
                    <a-input-search
                        style="width: 300px"
                        v-model="searchText"
                        :placeholder="$t('message.search')"
                        class="row search-input"
                        @input="onSearch($event.target.value)"
                    />
                    <CommonFilterTool
                        v-model="breakdownFilter"
                        :keep-state-on-query-params="false"
                        :filter-meta="filterMetas"
                        :label-formatter="filterLabelFormatter"
                        @addFilter="addFilter"
                    />
                </div>
                <div>
                    <SupsisButton ghost primary @click="syncLeads"
                        ><i class="material-icons">sync</i> {{$t("message.syncLeeds")}}
                    </SupsisButton>
                </div>
            </div>
            <SupsisTable
                :columns="getCols()"
                :rows="leads"
                top-pagination
                empty-data-bordered
                bottom-pagination
                :pagination-cursor="pagination"
                :options="{
                    checkboxOption,
                    rowStyleOption,
                    clipboardOption,
                    fixedHeader: true,
                    id: 'leads-table',
                    borderX: true,
                    borderY: true,
                }"
                @cursor-changed="(cursor) => (pagination = cursor)"
            />
            <NoMessage :title="$t('message.forbiddenChannel')" :desc="$t('message.forbiddenChannelDesc')" v-if="forbidden" />
        </div>
        <Modal2
            v-if="showWhatsappChatStarterModal"
            :show-footer="false"
            class="modal-wp-chat-starter"
            :title="$t('wpStartChat')"
            @cancel="() => (showWhatsappChatStarterModal = false)"
        >
            <WhatsappChatStarter
                :default-phone-number="selectedRow.phone"
                channel-override
                phone-number-override
                v-if="selectedRow"
                @close="() => (showWhatsappChatStarterModal = false)"
                :default-email="selectedRow.email"
                :default-name="selectedRow.name"
            />
        </Modal2>
    </div>
</template>
<script>
import SYSTEM_PUBSUB from "../../../../utils/systemPubSub";
import { sendSocketMessage, socketMessageStream } from "../../../../utils/socketStream";
import { filter, first, timeout } from "rxjs/operators";
import _ from "lodash";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import Vue from "vue";
import VueTheMask from "vue-the-mask";
import VueCountryCode from "vue-country-code";
import log2 from "../../../../utils/log2";
import Modal2 from "../../../../components/common/Modal2.vue";
import { VeLocale, VePagination } from "vue-easytable";
import enUS from "vue-easytable/libs/locale/lang/en-US.js";
import moment from "moment";
import SupsisButton from "../../Settings/components/SupsisButton.vue";
import NoMessage from "../../TeamChat/NoMessage.vue";
import SupsisTable from "../../../../components/SupsisTable.vue";
import CommonFilterTool from "../../Chatbot/pages/archive/CommonFilterTool.vue";
import { LEAD_API } from "../../../../api/meta";
import { CONTACT_API } from "../../../../api/visitor";
import HoverMenuCell from "../../../../components/common/HoverMenuCell.vue";
import WhatsappChatStarter from "./WhatsappChatStarter.vue";
import TicketStatusSwitcher from "../../Ticket/components/TicketStatusSwitcher.vue";
import { updateVisitorMultiKey } from "../../../../api/visitor";
import AiVoiceAgentCallStarter from "../../../../components/AiVoiceAgentCallStarter.vue";

Vue.use(VePagination);
VeLocale.use(enUS);
Vue.use(VueTheMask);
Vue.use(VueCountryCode);
const log = log2("LeadList");
export default {
    name: "LeadList",
    components: {
        WhatsappChatStarter,
        CommonFilterTool,
        SupsisTable,
        NoMessage,
        Modal2,
        SupsisButton,
        HoverMenuCell,
        TicketStatusSwitcher,
        AiVoiceAgentCallStarter,
    },

    props: {
        channel: {
            type: Object,
            required: true,
        },
        channelId: {
            type: String,
            required: true,
        },
        showTitle: {
            type: Boolean,
            default: true,
        },
        forbidden: {
            type: Boolean,
            default: false,
        },
        formMode: {
            type: Boolean,
            default: false,
        },
        formId: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            selectedRow: null,
            showWhatsappChatStarterModal: false,
            importMode: false,
            rowStyleOption: {
                stripe: true,
            },
            clipboardOption: {
                copy: true,
                paste: false,
                cut: false,
                delete: false,
            },
            services: null,
            visible: false,
            confirmLoading: false,
            showAlertMessage: false,
            internationalCallingCode: "90",
            wpContactNumber: "",
            createCustomerGroupFormVisible: false,
            lastPersonelContacts: [],
            searchText: "",
            currentSort: {
                columnKey: "connectionTime",
                order: "ascend",
            },
            pagination: {
                page: 1,
                perPage: 10,
                total: 0,
                defaultPageSize: 50,
                hideOnSinglePage: true,
                pageSizeOptions: [10, 15, 20, 50, 100],
                showQuickJumper: true,
                showSizeChanger: true,
            },
            loading: true,
            loadingInstance: null,
            leads: [],
            checkboxOption: {
                selectedRowKeys: [],
                // row select change event
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    console.log("selectedRowChange", { row, isSelected, selectedRowKeys });
                    this.checkboxOption.selectedRowKeys = selectedRowKeys;
                },
                // selected all change event
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    console.log("selectedAllChange", { isSelected, selectedRowKeys });
                    this.checkboxOption.selectedRowKeys = selectedRowKeys;
                },
            },
            filterMetas: [
                {
                    name: "metaLeadInfo.archived",
                    label: this.$t("message.archivedIn"),
                    defaultValue: null,
                    materialIcon: "check_circle",
                    controlType: "custom-picker",
                    controlProps: {
                        multiple: false,
                        idKey: "id",
                        labelKey: "label",
                        title: this.$t("message.makeSelect"),
                    },
                    filterValue: false,
                    options: () => [
                        { id: false, label: this.$t("message.no") },
                        { id: true, label: this.$t("message.yes") },
                        { id: null, label: this.$t("message.doesntMatter") },
                    ],
                },
                {
                    name: "metaLeadInfo.status",
                    label: this.$t("message.status"),
                    materialIcon: "flag",
                    controlType: "select",
                    defaultValue: null,
                    options: () => [
                        { id: "new_lead", label: this.$t("message.newLead") },
                        { id: "initial_contact", label: this.$t("message.firstContact") },
                        { id: "needs_assessment", label: this.$t("message.needsAnalysis") },
                        { id: "proposal_sent", label: this.$t("message.offerSent") },
                        { id: "proposal_review", label: this.$t("message.offerReview") },
                        { id: "negotiation", label: this.$t("message.negotiation") },
                        { id: "decision_stage", label: this.$t("message.decisionPhase") },
                        { id: "closure", label: this.$t("message.closure") },
                        { id: "follow_up", label: this.$t("message.followUp") },
                    ],
                },
                {
                    name: "metaLeadInfo.campaign_id",
                    label: this.$t("message.campagin"),
                    materialIcon: "filter_alt",
                    controlType: "select",
                    defaultValue: null,
                    options: () =>
                        this.distinctAdFilters.campaigns.map((value) => ({
                            id: value.id,
                            label: value.name,
                        })),
                },
                {
                    name: "metaLeadInfo.adset_id",
                    label: this.$t("message.adSet"),
                    materialIcon: "filter_alt",
                    controlType: "select",
                    defaultValue: null,
                    options: () =>
                        this.distinctAdFilters.adsets.map((value) => ({
                            id: value.id,
                            label: value.name,
                        })),
                },
                {
                    name: "metaLeadInfo.ad_id",
                    label: this.$t("message.ad"),
                    materialIcon: "filter_alt",
                    controlType: "select",
                    defaultValue: null,
                    options: () =>
                        this.distinctAdFilters.ads.map((value) => ({
                            id: value.id,
                            label: value.name,
                        })),
                },
                {
                    name: "metaLeadInfo.form_id",
                    label: "Form",
                    materialIcon: "filter_alt",
                    controlType: "select",
                    defaultValue: null,
                    options: () =>
                        this.distinctAdFilters.forms.map((value) => ({
                            id: value.id,
                            label: value.name,
                        })),
                },
                {
                    name: "metaLeadInfo.platform",
                    label: this.$t("message.platform"),
                    materialIcon: "filter_alt",
                    controlType: "select",
                    defaultValue: null,
                    options: () => [
                        {
                            id: "ig",
                            label: "Instagram",
                        },
                        {
                            id: "fb",
                            label: "Facebook",
                        },
                    ],
                },
                {
                    name: "email",
                    label: this.$t("message.email"),
                    materialIcon: "email",
                    controlType: "input",
                    defaultValue: null,
                },
            ],
            breakdownFilter: [
                {
                    name: "metaLeadInfo.form_id",
                    label: "Form",
                    filterValue: null,
                    materialIcon: "filter_alt",
                    controlType: "select",
                    options: () =>
                        this.distinctAdFilters.forms.map((value) => ({
                            id: value.id,
                            label: value.name,
                        })),
                },
                //arşivlenmemişler
                {
                    name: "metaLeadInfo.archived",
                    label: this.$t("message.archivedIn"),
                    defaultValue: null,
                    filterValue: false,
                    materialIcon: "check_circle",
                    controlType: "custom-picker",
                    controlProps: {
                        multiple: false,
                        idKey: "id",
                        labelKey: "label",
                        title: this.$t("message.makeSelect"),
                    },
                    options: () => [
                        { id: false, label: this.$t("message.no") },
                        { id: true, label: this.$t("message.yes") },
                        { id: null, label: this.$t("message.doesntMatter") },
                    ],
                },
                {
                    name: "metaLeadInfo.status",
                    label: this.$t("message.status"),
                    filterValue: null,
                    materialIcon: "flag",
                    controlType: "select",
                    options: () => [
                        { id: "new_lead", label: this.$t("message.newLead") },
                        { id: "initial_contact", label: this.$t("message.firstContact") },
                        { id: "needs_assessment", label: this.$t("message.needsAnalysis") },
                        { id: "proposal_sent", label:  this.$t("message.offerSent") },
                        { id: "proposal_review", label: this.$t("message.offerReview") },
                        { id: "negotiation", label: this.$t("message.negotiation") },
                        { id: "decision_stage", label: this.$t("message.decisionPhase") },
                        { id: "closure", label: this.$t("message.closure") },
                        { id: "follow_up", label: this.$t("message.followUp") },
                    ],
                },
            ],
            distinctAdFilters: {
                forms: [],
                ads: [],
                adsets: [],
                campaigns: [],
            },
            forms: [],
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            siteId: (state) => state.site.site._id,
            user: (state) => state.auth.user,
            whatsappChannels: (state) => state.channel.channels.filter((x) => x.type.startsWith("whatsapp")),
        }),

        ...mapGetters({
            myActiveConversations: "chat/getMyActiveConversations",
        }),
    },
    created() {
        this.breakdownFilter = [
            {
                name: "metaLeadInfo.form_id",
                label: "Form",
                filterValue: this.formId,
                readonly: !!this.formId,
                materialIcon: "filter_alt",
                controlType: "select",
                options: () =>
                    this.distinctAdFilters.forms.map((value) => ({
                        id: value.id,
                        label: value.name,
                    })),
            },
            //arşivlenmemişler
            {
                name: "metaLeadInfo.archived",
                label: this.$t("message.archivedIn"),
                defaultValue: null,
                filterValue: false,
                materialIcon: "check_circle",
                controlType: "custom-picker",
                controlProps: {
                    multiple: false,
                    idKey: "id",
                    labelKey: "label",
                    title: this.$t("message.makeSelect"),
                },
                options: () => [
                    { id: false, label: this.$t("message.no") },
                    { id: true, label:  this.$t("message.yes") },
                    { id: null, label:  this.$t("message.doesntMatter") },
                ],
            },
            {
                name: "metaLeadInfo.status",
                label: this.$t("message.status"),
                filterValue: null,
                materialIcon: "flag",
                controlType: "select",
                options: () => [
                    { id: "new_lead", label: this.$t("message.newLead") },
                    { id: "initial_contact", label: this.$t("message.firstContact") },
                    { id: "needs_assessment", label: this.$t("message.needsAnalysis") },
                    { id: "proposal_sent", label:  this.$t("message.offerSent") },
                    { id: "proposal_review", label: this.$t("message.offerReview") },
                    { id: "negotiation", label: this.$t("message.negotiation") },
                    { id: "decision_stage", label: this.$t("message.decisionPhase") },
                    { id: "closure", label: this.$t("message.closure") },
                    { id: "follow_up", label: this.$t("message.followUp") },
                ],
            },
        ];
    },
    methods: {
        syncLeads() {
            sendSocketMessage("meta sync-leads", {
                siteId: this.siteId,
                channelId: this.channel._id,
            });
        },
        addFilter(name, value) {
            log.info("addFilter", name);
            const meta = this.filterMetas.find((x) => x.name === name);
            const filter = this.breakdownFilter.find((x) => x.name === name);
            if (filter) {
                this.breakdownFilter = this.breakdownFilter.map((x) => {
                    if (x.name === name) {
                        x.filterValue = value || meta.defaultValue;
                    }
                    return x;
                });
            } else {
                this.breakdownFilter.push({
                    name: meta.name,
                    label: meta.label,
                    filterValue: value || meta.defaultValue,
                    materialIcon: meta.materialIcon,
                    controlType: meta.controlType,
                    options: meta.options,
                });
            }
        },
        removeFilter(name) {
            log.info("removeFilter", name);
            this.breakdownFilter = this.breakdownFilter.filter((x) => x.name !== name);
        },
        filterLabelFormatter(name, value) {
            const filter = this.filterMetas.find((x) => x.name === name);
            log.info("filterLabelFormatter", { name, value, filter });
            const isSelect = filter.controlType === "select";
            if (isSelect) {
                const option = filter.options().find((x) => x.id === value);
                if (option) {
                    return `${filter.label}: ${option.label}`;
                }
            } else if (filter.controlType === "custom-picker") {
                const values = Array.isArray(value) ? value : [value];
                const selectedValues = values
                    .map((value) => {
                        const option = filter.options().find((x) => x.id == value);
                        return option?.label || value;
                    })
                    .filter(Boolean);
                return `${filter.label}: ${selectedValues.join(", ")}`;
            }
            if (value) {
                return `${filter.label}: ${value}`;
            }
            return filter.label;
        },
        isFilterExists(name) {
            return !!this.breakdownFilter.find((x) => x.name === name);
        },
        getFormCols() {
            let results = [];
            if (this.formId && this.formMode) {
                const form = this.forms.find((x) => x.formId === this.formId);
                if (form) {
                    results = form.questions.map((q) => ({
                        key: q.key,
                        field: q.key,
                        title: "FQ:" + q.label,
                        width: "",
                        align: "left",
                        renderBodyCell: ({ row, column, rowIndex }, h) => {
                            const answers = row.metaLeadInfo?.field_data || [];
                            const answer = answers.find((x) => x.name === q.key)?.values?.join(",") || "-";
                            console.log("getFormCols inside", {
                                q,
                                row,
                                answers,
                                answer,
                            });
                            return <span>{answer}</span>;
                        },
                    }));
                }
            }
            console.log("getFormCols", {
                formId: this.formId,
                formMode: this.formMode,
                forms: this.forms,
                cols: results,
            });
            return results;
        },
        getCols() {
            return [
                {
                    field: "",
                    key: "a",
                    type: "checkbox",
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "address",
                    key: "profilePicThumbObj",
                    title: this.$t("message.profile"),
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return h(
                            "a-avatar",
                            {
                                props: {
                                    size: 30,
                                    src: row.instagramInfo?.profile_pic,
                                    username: row.name,
                                    shape: "square",
                                },
                                style: "background-color: #3899ff; border-radius: 7px !important",
                            },
                            row.name.substr(0, 1).toLocaleUpperCase()
                        );
                    },
                },
                ...this.getFormCols(),
                {
                    key: "name",
                    field: "name",
                    title: this.$t("message.name"),
                    width: "",
                    align: "left",
                },
                {
                    key: "phone",
                    field: `phone`,
                    title: this.$t("message.number"),
                },
                {
                    key: "email",
                    field: `email`,
                    title: "Email",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return h(
                            HoverMenuCell,
                            {
                                props: {
                                    filterAdd: !this.isFilterExists("email"),
                                    filterRemove: this.isFilterExists("email"),
                                    copy: true,
                                },
                                on: {
                                    filterAdded: () => {
                                        this.addFilter("email", row.email);
                                    },
                                    filterRemoved: () => {
                                        this.removeFilter("email");
                                    },
                                },
                            },
                            [h("span", row.email || "-")]
                        );
                    },
                },
                {
                    key: "metaLeadInfo.adset_name",
                    field: `metaLeadInfo.adset_name`,
                    title: this.$t("message.adSet"),
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return h(
                            HoverMenuCell,
                            {
                                props: {
                                    filterAdd: !this.isFilterExists("email"),
                                    filterRemove: this.isFilterExists("email"),
                                    copy: true,
                                },
                                on: {
                                    filterAdded: () => {
                                        this.addFilter("metaLeadInfo.adset_id", row.metaLeadInfo.adset_id);
                                    },
                                    filterRemoved: () => {
                                        this.removeFilter("metaLeadInfo.adset_id");
                                    },
                                },
                            },
                            [h("span", row.metaLeadInfo?.adset_name)]
                        );
                    },
                },
                {
                    key: "metaLeadInfo.ad_name",
                    field: `metaLeadInfo.ad_name`,
                    title: this.$t("message.ad"),
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return h(
                            HoverMenuCell,
                            {
                                props: {
                                    filterAdd: !this.isFilterExists("email"),
                                    filterRemove: this.isFilterExists("email"),
                                    copy: true,
                                },
                                on: {
                                    filterAdded: () => {
                                        this.addFilter("metaLeadInfo.ad_id", row.metaLeadInfo.ad_id);
                                    },
                                    filterRemoved: () => {
                                        this.removeFilter("metaLeadInfo.ad_id");
                                    },
                                },
                            },
                            [h("span", row.metaLeadInfo?.ad_name)]
                        );
                    },
                },
                {
                    key: "metaLeadInfo.campaign_name",
                    field: `metaLeadInfo.campaign_name`,
                    title: this.$t("message.campagin"),

                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return h(
                            HoverMenuCell,
                            {
                                props: {
                                    filterAdd: !this.isFilterExists("email"),
                                    filterRemove: this.isFilterExists("email"),
                                    copy: true,
                                },
                                on: {
                                    filterAdded: () => {
                                        this.addFilter("metaLeadInfo.campaign_id", row.metaLeadInfo.campaign_id);
                                    },
                                    filterRemoved: () => {
                                        this.removeFilter("metaLeadInfo.campaign_id");
                                    },
                                },
                            },
                            [h("span", row.metaLeadInfo?.campaign_name)]
                        );
                    },
                },
                {
                    key: "metaLeadInfo.metaForm.name",
                    field: `metaLeadInfo.metaForm.name`,
                    title: "Form",

                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return h(
                            HoverMenuCell,
                            {
                                on: {
                                    filterAdded: () => {
                                        this.addFilter("metaLeadInfo.form_id", row.metaLeadInfo?.form_id);
                                    },
                                    filterRemoved: () => {
                                        this.removeFilter("metaLeadInfo.form_id");
                                    },
                                },
                            },
                            [h("span", row.metaLeadInfo?.metaForm?.name)]
                        );
                    },
                },
                {
                    key: "metaLeadInfo.platform",
                    field: `metaLeadInfo.platform`,
                    title: this.$t("message.platform"),

                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return h(
                            HoverMenuCell,
                            {
                                on: {
                                    filterAdded: () => {
                                        this.addFilter("metaLeadInfo.platform", row.metaLeadInfo?.platform);
                                    },
                                    filterRemoved: () => {
                                        this.removeFilter("metaLeadInfo.platform");
                                    },
                                },
                            },
                            [
                                h(
                                    "span",
                                    { ig: "Instagram", fb: "Facebook" }[row.metaLeadInfo?.platform] ||
                                        row.metaLeadInfo?.platform
                                ),
                            ]
                        );
                    },
                },
                {
                    key: "channelName",
                    field: `channelName`,
                    title: this.$t("message.channel"),
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return <span>{row.channel?.name || "-"}</span>;
                    },
                },
                {
                    key: "createdAt",
                    field: `createdAt`,
                    title: this.$t("message.createdAt"),
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        const date = row.metaLeadInfo?.created_time || row.createdAt;
                        return <span>{moment(date).format("DD.MM.YYYY HH:mm")}</span>;
                    },
                },
                {
                    title: this.$t("message.status"),
                    field: "metaLeadInfo.status",
                    key: "status",
                    width: 300,
                    renderBodyCell: ({ row }) => {
                        const statusList = [
                            { title: "new_lead", label: this.$t("message.newLead") },
                            { title: "initial_contact", label: this.$t("message.firstContact") },
                            { title: "needs_assessment", label: this.$t("message.needsAnalysis") },
                            { title: "proposal_sent", label:  this.$t("message.offerSent") },
                            { title: "proposal_review", label: this.$t("message.offerReview") },
                            { title: "negotiation", label: this.$t("message.negotiation") },
                            { title: "decision_stage", label: this.$t("message.decisionPhase") },
                            { title: "closure", label: this.$t("message.closure") },
                            { title: "follow_up", label: this.$t("message.followUp") },
                        ];

                        const currentStatus = row.metaLeadInfo?.status || "new_lead";

                        return (
                            <TicketStatusSwitcher
                                currentStatus={currentStatus}
                                statusList={statusList}
                                v-on:update-status={(newStatus) => this.handleStatusChange(row, newStatus)}
                            />
                        );
                    },
                },
                {
                    title: this.$t("message.archived"),
                    field: "metaLeadInfo.archived",
                    key: "archived",
                    width: 120,
                    renderBodyCell: ({ row }) => {
                        const isArchived = row.metaLeadInfo?.archived ?? false;
                        return (
                            <div class={`chip ${isArchived ? "archived" : "active"}`}>
                                {isArchived ? "Arşivlendi" : "Aktif"}
                            </div>
                        );
                    },
                },
                {
                    title: this.$t("message.action"),
                    key: "operation",
                    width: "180px",
                    align: "center",
                    operationColumn: true,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <div class="actions">
                                <SupsisButton onClick={() => this.startChat(row)} small
                                    content={this.$t("chatbotv2.QUICK_REPLY")}
                                    v-tippy={{ followCursor: true, placement: "bottom-end" }}>
                                    <i class="material-icons text-primary">quickreply</i>
                                </SupsisButton>
                                <AiVoiceAgentCallStarter
                                    contact={row}
                                    defaultToNumber={row.phone}
                                    hideButton={false}
                                />
                                <SupsisButton 
                                    onClick={() => this.startWebphoneCall(row)} 
                                    small
                                    class="webphone-call-btn"
                                    v-show={row.phone}
                                    content="Webphone ile Ara"
                                    v-tippy={{ followCursor: true, placement: "bottom-end" }}
                                >
                                    <i class="material-icons">phone</i>
                                </SupsisButton>
                                <SupsisButton onClick={() => this.deleteVisitorConfirm(row)} small
                                    content={this.$t("chatbotv2.delete")}
                                    v-tippy={{ followCursor: true, placement: "bottom-end" }}>
                                    <i class="material-icons text-danger">delete</i>
                                </SupsisButton>
                                <SupsisButton onClick={() => this.viewContactProfile(row)} small
                                    content={this.$t("message.contactPage")}
                                    v-tippy={{ followCursor: true, placement: "bottom-end" }}>
                                    <i class="material-icons text-primary">contact_page</i>
                                </SupsisButton>
                                <SupsisButton onClick={() => this.archiveLeadConfirm(row)} small
                                    content={this.$t("message.archive")}
                                    v-tippy={{ followCursor: true, placement: "bottom-end" }}>
                                    <i class="material-icons text-warning">archive</i>
                                </SupsisButton>
                            </div>
                        );
                    },
                },
            ];
        },
        ...mapActions({
            deleteVisitor: "visitor/deleteVisitor",
            deleteMultiVisitor: "visitor/deleteMultiVisitor",
            addNewWindow: "app/addNewWindow",
        }),
        ...mapMutations({}),

        selectAll() {
            this.checkboxOption.selectedRowKeys = this.leads.map((x) => x._id);
        },
        deleteAll() {
            this.$confirm({
                title: this.$t("message.deletedSelectedPerson"),
                content: this.$t("message.sureDelSelectedPerson"),
                okText: this.$t("message.delete"),
                okType: "danger",
                cancelText: this.$t("message.close"),
                onOk: () => {
                    this.deleteMultiVisitor(this.checkboxOption.selectedRowKeys).then((isSuccess) => {
                        if (isSuccess) {
                            this.$message.success(`${this.checkboxOption.selectedRowKeys.length} ${this.$t("message.personDeleted")}`);
                            this.leads = this.leads.filter((x) => !this.checkboxOption.selectedRowKeys.includes(x._id));
                            this.checkboxOption.selectedRowKeys = [];
                            this.refresh();
                        }
                    });
                },
            });
        },
        unselectAll() {
            this.checkboxOption.selectedRowKeys = [];
        },
        deleteVisitorConfirm(item) {
            this.$confirm({
                title: this.$t("message.deletePerson"),
                content: this.$t("message.sureDeletePerson"),
                okText: this.$t("message.delete"),
                okType: "danger",
                cancelText: this.$t("message.close"),
                onOk: () => {
                    this.deleteVisitor(item._id).then((res) => {
                        this.$message.success(this.$t("message.personDeleted"));
                        this.leads = this.leads.filter((x) => x._id !== item._id);
                    });
                },
            });
        },
        viewContactProfile(item) {
            this.addNewWindow({
                type: "show-visitor",
                // title: `${item.name} / ${item.phoneNumber} Profile`,
                title: this.$t("message.instagramUserProfile") + "/" + `${item.name}`,
                payload: {
                    visitorId: item._id,
                },
                footer: false,
                sliderOptions: {
                    nextAvailable: !!this.leads[this.leads.indexOf(item) + 1],
                    prevAvailable: !!this.leads[this.leads.indexOf(item) - 1],
                    next: () => {
                        log("next called");
                        const index = this.leads.findIndex((x) => x._id === item._id);
                        this.viewContactProfile(this.leads[index + 1]);
                    },
                    prev: () => {
                        log("prev called");
                        const index = this.leads.findIndex((x) => x._id === item._id);
                        this.viewContactProfile(this.leads[index - 1]);
                    },
                },
            });
        },
        startChat(row) {
            if (row.phone) {
                this.selectedRow = row;
                this.showWhatsappChatStarterModal = true;
            } else {
                this.$message.error(this.$t("message.phoneNumberNotAvailable"));
            }
        },
        refresh: _.debounce(function () {
            this.loading = true;
            setTimeout(() => {
                this.loading = false;
            }, 500);
            this.pagination.page = 1;
            this.fetchLeads();
        }, 400),

        async handleTableChange(pagination, filters, sorter) {
            this.loading = true;
            setTimeout(() => {
                this.loading = false;
            }, 370);
            this.pagination.page = pagination.page;
            this.pagination.perPage = pagination.perPage;
            await this.fetchLeads();
        },
        onSearch(value) {
            log("onSearch", value);
            this.searchText = value;
            this.refresh();
        },
        async fetchDistinctFilters() {
            LEAD_API.distinctAdFilters().then((res) => {
                this.distinctAdFilters = res.data;
            });
        },
        async fetchForms() {
            LEAD_API.listForms([{ key: "channel", value: this.channelId, operator: "equals" }], {
                page: 0,
                perPage: 100,
            }).then((res) => {
                this.forms = res.data.items;
            });
        },
        generateFilterParams() {
            return this.breakdownFilter
                .map((filter) => {
                    if (!!filter.filterValue || typeof filter.filterValue === "boolean") {
                        return {
                            key: filter.name,
                            value: filter.filterValue,
                            operator: "equals",
                        };
                    }
                    return undefined;
                })
                .filter((x) => !!x);
        },
        async fetchLeads() {
            if (!this.channel) return;
            if (this.forbidden) {
                this.loading = false;
                this.leads = [];
                this.pagination.total = 0;
                this.searchText = "";
                return;
            }
            this.loading = true;
            if (this.distinctAdFilters.forms.length === 0) {
                this.fetchDistinctFilters();
            }
            if (this.forms.length === 0) {
                this.fetchForms();
            }
            const cursor = {
                offset: (this.pagination.page - 1) * this.pagination.perPage,
                limit: this.pagination.perPage,
            };
            const filters = [
                {
                    key: "platform",
                    value: "meta-leads",
                    operator: "equals",
                },
                this.channel
                    ? {
                          key: "channel",
                          value: this.channel._id,
                          operator: "equals",
                      }
                    : undefined,
                (this.searchText || "").trim().length > 0
                    ? {
                          key: "*",
                          value: (this.searchText || "").trim(),
                      }
                    : undefined,
                ...this.generateFilterParams(),
            ].filter((x) => !!x);
            const sort = { createdAt: -1 };
            const leads = await CONTACT_API.listContacts(cursor, filters, sort);

            console.log("leads request:", leads);

            this.leads = leads.result.map((x) => {
                x.channelName = !!x.channel ? x.channel.name : "-";
                x.name = !!x.fullname ? x.fullname : "-";
                x.phoneNumber = !!x.whatsappNumber ? x.whatsappNumber : "-";
                return x;
            });
            this.pagination.total = leads.totalResult;
            this.loading = false;
        },
        handleStatusChange(lead, newStatus) {
            updateVisitorMultiKey(lead._id, {
                metaLeadInfo: {
                    ...lead.metaLeadInfo,
                    status: newStatus,
                },
            })
                .then(() => {
                    this.$message.success(this.$t("message.statusSucsUpdated"));
                    // State'i güncelle
                    const index = this.leads.findIndex((item) => item._id === lead._id);
                    if (index !== -1) {
                        this.$set(this.leads[index], "metaLeadInfo", {
                            ...this.leads[index].metaLeadInfo,
                            status: newStatus,
                        });
                    }
                })
                .catch((error) => {
                    this.$message.error(this.$t("message.statusUpdatedFailed"));
                    console.error("Durum güncelleme hatası:", error);
                });
        },
        archiveLeadConfirm(item) {
            this.$confirm({
                title: this.$t("message.archivedContact"),
                content: this.$t("message.sureWantArchivePerson"),
                okText: this.$t("message.archived"),
                okType: "warning",
                cancelText: this.$t("message.cancel"),
                onOk: () => {
                    updateVisitorMultiKey(item._id, {
                        metaLeadInfo: {
                            ...item.metaLeadInfo,
                            archived: true,
                        },
                    })
                        .then(() => {
                            this.$message.success(this.$t("message.personArchived"));
                            // State'i güncelle
                            const index = this.leads.findIndex((lead) => lead._id === item._id);
                            if (index !== -1) {
                                this.$set(this.leads[index], "metaLeadInfo", {
                                    ...this.leads[index].metaLeadInfo,
                                    archived: true,
                                });
                            }
                        })
                        .catch((error) => {
                            this.$message.error(this.$t("message.personArchivedHead"));
                            console.error("Arşivleme hatası:", error);
                        });
                },
            });
        },
        startWebphoneCall(contact) {
            const phoneNumber = contact.phone || contact.whatsappNumber;
            
            if (!phoneNumber) {
                this.$message.warning("Aranacak numara bulunamadı");
                return;
            }

            // Webphone'a arama başlatma event'i gönder
            SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.WEBPHONE_CALL_START, {
                phoneNumber: phoneNumber,
                contactName: contact.fullname || contact.name || "Bilinmeyen",
                contactId: contact._id
            });

            this.$message.success(`Webphone ile ${phoneNumber} aranıyor...`);
        },
    },
    async mounted() {
        this.loadingInstance = this.$veLoading({
            target: document.querySelector(".table-wrapper"),
            name: "wave",
        });
        this.loading = !!this.channel && !this.forbidden;
        if (this.loading) this.loadingInstance.show();
        await this.fetchLeads();
    },
    watch: {
        loading(val) {
            if (val) {
                this.loadingInstance.show();
            } else {
                this.loadingInstance.close();
            }
        },
        channelId(val) {
            this.searchText = "";
            this.pagination.page = 1;
            this.fetchLeads();
        },
        pagination: {
            handler(val, oldVal) {
                const pageSizeChanged = val.perPage !== oldVal.perPage;
                if (pageSizeChanged) {
                    this.pagination.page = 1;
                }
                console.log("pagination changed", val);
                this.fetchLeads();
            },
            deep: true,
        },
        breakdownFilter: {
            handler(val, oldVal) {
                this.fetchLeads();
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss">
#leads-table {
    .ve-table-body-td {
        padding: 0 2px !important;
    }

    .actions {
        display: flex;
        gap: 5px;

        .supsis-button {
            background: none;
            border: none;
            padding: 3px;

            &.instagram {
                width: 25px;
                height: 25px;
            }

            svg {
                width: 20px;
                height: 20px;
            }
        }

        /* AI Voice Agent Button Styling */
        .ai-voice-agent-call-starter {
            display: inline-flex;

            .conversation-actions-button {
                padding: 4px;
                background: none;
                border: none;
                cursor: pointer;

                .material-icons {
                    font-size: 20px;
                }
            }
        }

        /* Webphone Call Button Styling */
        .webphone-call-btn {
            background-color: #34c759 !important;
            color: white !important;
            border: none !important;
            
            &:hover {
                background-color: #2fb653 !important;
                color: white !important;
                transform: scale(1.05);
                box-shadow: 0 2px 6px rgba(52, 199, 89, 0.3);
            }
            
            .material-icons {
                color: white !important;
                font-size: 18px;
            }
        }
    }
}
</style>
<style lang="scss">
#lead-list-page {
    margin: 30px;

    .chip {
        padding: 4px 8px;
        border-radius: 16px;
        font-size: 12px;
        font-weight: bold;
        text-align: center;

        &.archived {
            background-color: #ffa500;
            color: white;
        }

        &.active {
            background-color: #4caf50;
            color: white;
        }
    }

    .toolbar {
        width: 100%;
        display: flex;
        justify-content: space-between;

        padding: 10px 0;
        gap: 5px;

        .common-filter-tool {
            border-bottom: none !important;
        }

        .toolbar-filter {
            display: flex;
            align-items: center;
        }
    }

    .toolbox {
        display: flex;
        justify-content: space-between;

        .buttons {
            display: flex;
            gap: 10px;
        }
    }

    .delete-chat {
        background: none;
        border: none;
        margin-right: 5px;

        &:hover {
            background-color: #c0bfbf;
            border-radius: 10px;
        }
    }

    .ant-modal-body {
        padding: 24px;
        font-size: 14px;
        line-height: 1.5;
        word-wrap: break-word;
        display: flex !important;
        flex-direction: row !important;
        height: 80px !important;
    }

    .ant-table-row {
        border-bottom: 1px solid lightgrey;
    }

    .ant-table table {
        border-collapse: collapse !important;
    }

    .ant-table-small {
        border: none !important;
    }

    .ant-table-body > table > .ant-table-tbody > tr > td {
        border: none !important;
    }

    .ant-table-body > table {
        border-right: none !important;
        border-left: none !important;
        line-height: 10px !important;
    }

    .ant-table-body > table > .ant-table-thead > tr > th {
        border: none !important;
    }

    .ant-table-small {
        .ant-table-tbody {
            td {
                padding: 2px 2px !important;
                height: 10px !important;
            }

            .ant-table-row {
                height: 10px !important;
            }
        }
    }

    .selection-bar {
        align-items: center;
        background: #006cff;
        color: #fff;
        display: flex;
        flex-wrap: wrap;
        height: 50px;
        left: 0;
        padding: 10px 30px;
        position: static;
        right: 0;

        section.uncheck {
            align-items: center;
            cursor: pointer;
            display: flex;
            grid-area: uncheck;
            transition: all 0.3s;

            &:hover {
                opacity: 0.8 !important;
            }

            .material-icons {
                font-size: 15px;
                margin-right: 10px;
                margin-top: 2px;
            }
        }

        section.select {
            cursor: pointer;
            grid-area: select;
            margin-left: 20px;
            transition: all 0.3s;

            &:hover {
                opacity: 0.8 !important;
            }
        }

        section.queries {
            grid-area: queries;
            margin-left: auto;
        }

        section.actions {
            align-items: center;
            display: flex;
            grid-area: actions;
            justify-content: center;
            margin-left: 20px;
            gap: 5px;

            div {
                align-items: center;
                border: 1px solid #fff;
                border-radius: 100%;
                cursor: pointer;
                display: flex;
                height: 26px;
                justify-content: center;
                margin: 0 5px;
                transition: opacity 0.3s;
                width: 26px;

                .material-icons {
                    color: #fff;
                    font-size: 15px;
                }
            }
        }
    }

    .wp-list-searching-input {
        margin: 5px 5px !important;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        text-align: center;
    }

    .inputs {
        border: 1px solid #e5e5e5;
        position: relative;
        border-radius: 6px;
        -webkit-box-shadow: 0 0 1px #00000080;
        box-shadow: 0 0 1px #00000080;
    }
}
</style>
<style lang="scss">
.import-contact-modal {
    .ant-modal {
        width: 91vw !important;
        top: 30px !important;
        left: 30px !important;
    }

    .ant-modal-content {
        height: 95vh !important;
    }

    .ant-modal-body,
    .custom-modal-content {
        height: 100%;
    }
}
</style>
